import { useEffect } from 'react';

/**
 * Global Dynamic Cursor Spotlight Hook
 * Tracks cursor coordinates across all .codex-card and .glass-panel elements
 * sets --mouse-x and --mouse-y CSS properties for hardware-accelerated radial lighting
 */
export const useSpotlight = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Check if device supports fine hover (desktop mouse) safely with JSDOM fallback
    const isHoverSupported = typeof window.matchMedia === 'function'
      ? window.matchMedia('(hover: hover) and (pointer: fine)').matches
      : true;

    if (!isHoverSupported) return;

    const handleMouseMove = (e) => {
      const cards = document.querySelectorAll('.codex-card, .glass-panel, .spotlight-card');
      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        card.style.setProperty('--mouse-x', `${x}px`);
        card.style.setProperty('--mouse-y', `${y}px`);
      });
    };

    window.addEventListener('mousemove', handleMouseMove, { passive: true });
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
};
